import React, { useState } from 'react';
import styled from "styled-components";

function Contact() {
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [questiontitle, setQuestiontitle] = useState();
  const [message, setMessage] = useState();

  const submitContact = e => {
    alert("submitted")
  }
  return (
    <Container>
        <Content>
            <br />
        <h2>Contact-Us</h2>
        <h4>Have a question or discovered a bug</h4>
            <Form>
                <p>Name *</p>
                <input type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="John Doe" required />

                <p>Email Address *</p>
                <input type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                 placeholder="johndoe@gmail.com" required />

                <p>Question Title</p>
                <input type="text"
                value={questiontitle}
                onChange={e => setQuestiontitle(e.target.value)}
                placeholder="This is my question" />

                <p>Message / Question *</p>
                <textarea rows="10"
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="This is my message"></textarea>

                <ContactButton onClick={submitContact}>Submit</ContactButton>
            </Form>
            <br />
        </Content>
    </Container>
  )
}

const Container = styled.div`
  width: 100vw;
`;

const Content = styled.div`
  width: 90vw;
  background: white;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 15%), 0 0 0 rgb(0 0 0 / 20%);

  h2 {
    margin-left: 4%;
    margin-top: 0%
  }

  h4 {
    margin-left: 4%;
    margin-top: -1%;
    font-weight: 400;

    @media(max-width: 768px) {
        margin-top: -3%;
    }
  }
`;

const Form = styled.div`
  margin-left: 6%;
  display: flex;
  flex-direction: column;

  @media(max-width: 768px) {
    margin-left: 9%;
  }

  p {
    font-size: 17px;
    font-weight: 400;
  }

  input {
    width: 50vw;
    height: 5vh;

    &:hover {
        background: whitesmoke;
        border: none;
    }

    @media(max-width: 768px) {
        width: 70vw;
        height: 5vh;
    }
  }

  textarea {
    width: 50vw;

    &:hover {
        background: whitesmoke;
        border: none;
    }

    @media(max-width: 768px) {
        width: 70vw;
    }
  }
`;

const ContactButton = styled.button`
  width: 20vw;
  height: 6vh;
  font-weight: 600;
  font-size: 17px;
  margin-top: 3%;
  background: orange;
  border: none;
  cursor: pointer;

  &:hover {
    border: 1px solid black;
  }

  @media(max-width: 768px) {
    width: 30vw;
    font-size: 15px;
  }
`;

export default Contact